export default __webpack_public_path__ + "static/junk-removal-b82c13490598689cfc229e6212a50c6e.jpg";